import React, { useState } from 'react';
import { IconButton, Tooltip, Snackbar, Alert } from '@mui/material';
import { Copy } from 'lucide-react';

const CopyableField = ({ value, label, truncate = true, maxWidth = 300 }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(value);
    setCopied(true);
  };

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
      <span style={{
        fontFamily: 'monospace', fontSize: '12px', color: '#555',
        ...(truncate ? { maxWidth, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' } : {})
      }}>
        {value}
      </span>
      <Tooltip title={label || 'Copiar'}>
        <IconButton size="small" onClick={handleCopy} sx={{ p: '2px' }}><Copy size={12} /></IconButton>
      </Tooltip>
      <Snackbar open={copied} autoHideDuration={1500} onClose={() => setCopied(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert severity="success" sx={{ fontSize: '12px' }}>Copiado!</Alert>
      </Snackbar>
    </span>
  );
};

export default CopyableField;
